document.addEventListener("DOMContentLoaded", function () {
	const forms = document.querySelectorAll(".ethical-subscription-form");
	forms.forEach(function (form) {
		form.addEventListener("submit", function (event) {
			event.preventDefault();
			const form = event.target;
			const actionUrl = form.getAttribute("action");
			const button = form.querySelector('button[type="submit"]');
			const originalButtonText = button.textContent;
			button.textContent = "Subscribing...";
			button.disabled = true;

			const formMessages = form.querySelector(
				".ethical-subscription-form__messages",
			);
			formMessages.innerHTML = "";

			const email = form.querySelector("input[name='email']").value;
			const edSubscribeNonce = form.querySelector(
				"input[name='ethical_subscribe_nonce']",
			).value;
			const name = form.querySelector("input[name='name']").value;
			const formData = new FormData();
			formData.append("email", email);
			formData.append("name", name);
			formData.append("ethical_subscribe_nonce", edSubscribeNonce);

			const urlEncodedData = new URLSearchParams(formData).toString();

			fetch(actionUrl, {
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
				body: urlEncodedData,
			})
				.then(function (response) {
					if (!response.ok) {
						return response.json().then(function (data) {
							throw new Error(data.message || "An unknown error occurred");
						});
					}
					return response.text();
				})
				.then(function () {
					const successMessage = document.createElement("p");
					successMessage.textContent =
						"Thank you for subscribing! Please check your inbox.";
					form.insertAdjacentElement("afterend", successMessage);
					form.remove();
				})
				.catch(function (error) {
					formMessages.innerHTML =
						'<p class="ethical-error">Oops, something went wrong!</p>';
				})
				.finally(function () {
					button.textContent = originalButtonText;
					button.disabled = false;
				});
		});
	});
});
